import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { FormError, FormLabel } from '../Form';
import EmailModelsMultiSelect from './EmailModelsMultiSelect';
import { EMAIL_LIST_ITEMS } from '../../constants/emailListItems';
import {
    EMAIL_MANAGEMENT_TYPE,
    EMAIL_PROCESS_OPTIONS,
    RECIPIENT_TYPE_OPTIONS,
} from '../../constants/emailManagementForm';

const EmailManagementConfigFields = ({
    register,
    errors,
    setValue,
    emailList = [],
    isSaving = false,
    emailManagementType = EMAIL_MANAGEMENT_TYPE.STANDARD,
    partnerField = null,
}) => {
    const isStandard = emailManagementType === EMAIL_MANAGEMENT_TYPE.STANDARD;

    if (isStandard) {
        return (
            <div
                className="aee-type-panel"
                role="tabpanel"
                id="aee-form-panel-standard"
                aria-labelledby="aee-type-tab-standard"
            >
                {partnerField}
                <div className="ow-form-field aee-field-models">
                    <FormLabel
                        text="Liste des e-mails autorisés"
                        htmlFor="email_list_trigger"
                        required
                    />
                    <p className="aee-field-hint" id="email_list_hint">
                        Emails envoyés pour ce partenaire.
                    </p>
                    <EmailModelsMultiSelect
                        id="email_list_trigger"
                        options={EMAIL_LIST_ITEMS}
                        value={emailList}
                        onChange={(next) =>
                            setValue('email_list', next, {
                                shouldDirty: true,
                                shouldValidate: true,
                            })
                        }
                        disabled={isSaving}
                        error={
                            errors.email_list?.message ||
                            errors.email_list?.root?.message
                        }
                    />
                    <FormError
                        message={
                            errors.email_list?.message ||
                            errors.email_list?.root?.message
                        }
                    />
                </div>

                <div className="ow-form-field">
                    <FormLabel
                        text="Envoyer les emails standard directement au"
                        htmlFor="recipient_type"
                        required
                    />
                    <div className="ow-form-select-wrap">
                        <select
                            id="recipient_type"
                            className={[
                                'ow-form-select',
                                errors.recipient_type && 'ow-form-select--error',
                            ]
                                .filter(Boolean)
                                .join(' ')}
                            {...register('recipient_type')}
                            disabled={isSaving}
                            aria-required="true"
                            aria-invalid={Boolean(errors.recipient_type)}
                        >
                            {RECIPIENT_TYPE_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                        <FiChevronDown className="ow-form-select-chevron" aria-hidden="true" />
                    </div>
                    <FormError message={errors.recipient_type?.message} />
                </div>
            </div>
        );
    }

    return (
        <div
            className="aee-type-panel"
            role="tabpanel"
            id="aee-form-panel-specifique"
            aria-labelledby="aee-type-tab-specifique"
        >
            {partnerField}
            <div className="ow-form-field">
                <FormLabel text="Processus Email" htmlFor="email_process" required />
                <div className="ow-form-select-wrap">
                    <select
                        id="email_process"
                        className={[
                            'ow-form-select',
                            errors.email_process && 'ow-form-select--error',
                        ]
                            .filter(Boolean)
                            .join(' ')}
                        {...register('email_process')}
                        disabled={isSaving}
                        aria-required="true"
                        aria-invalid={Boolean(errors.email_process)}
                    >
                        <option value="">Sélectionner un processus</option>
                        {EMAIL_PROCESS_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                    <FiChevronDown className="ow-form-select-chevron" aria-hidden="true" />
                </div>
                <FormError message={errors.email_process?.message} />
            </div>
        </div>
    );
};

export default EmailManagementConfigFields;
